export interface ReversedQuickFixCounts {
  reversedCount: number;
  matchedOnlyCount: number;
}

function voucherLabel(count: number): string {
  return count === 1 ? "voucher" : "vouchers";
}

export function reversedQuickFixConfirmation(
  monthLabel: string,
  start: string,
  end: string,
): string {
  return `This will reverse Nova vouchers proven REVERSED by Electrum, create the normal audit and accounting events, and mark successful reversals as matched for ${monthLabel} (${start} → ${end}). Continue?`;
}

export function reversedQuickFixSuccess({
  reversedCount,
  matchedOnlyCount,
}: ReversedQuickFixCounts): string {
  if (reversedCount === 0 && matchedOnlyCount === 0) {
    return "No reversed vouchers required updates.";
  }

  const reversed =
    reversedCount > 0
      ? `Reversed ${reversedCount} Nova ${voucherLabel(reversedCount)} and marked ${reversedCount === 1 ? "it" : "them"} as matched.`
      : "";
  const matchedOnly =
    matchedOnlyCount > 0
      ? `${reversed ? "finalised" : "Finalised"} matching for ${matchedOnlyCount} already-reversed ${voucherLabel(matchedOnlyCount)}.`
      : "";
  return reversed && matchedOnly
    ? `${reversed.slice(0, -1)}; ${matchedOnly}`
    : reversed || matchedOnly;
}
